import {epic as timeSeriesEpic, actions as timeSeriesActions} from './timeSeries';

export const actions = {...timeSeriesActions};
export const epic = timeSeriesEpic;
